module.exports = __webpack_public_path__ + "img/dibu.3003f541.png";